import { useCallback } from 'react';
import { SkippableFragmentType } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

import { useNextEpisode } from '../../../episode-player/hooks/use-next-episode';
import { useCurrentEpisode } from '../../../episode-player/hooks/use-current-episode';
import { setPlayingParams } from '../../utils/set-playing-params';
import { useStartPlayingContent } from '../../../player-manager/hooks/useStartPlayingContent';

type SkipTypes =
    | 'NEXT_EPISODE_BUTTON'
    | 'NEXT_EPISODE_AUTO_SKIP'
    | 'NEXT_EPISODE_AFTER_CREDITS'
    | 'NEXT_EPISODE_SELECT_SKIP';

type SwitchToNextEpisodeType = <T extends SkipTypes>(
    ...args: T extends 'NEXT_EPISODE_BUTTON' | 'NEXT_EPISODE_AFTER_CREDITS'
        ? [T]
        : [T, SkippableFragmentType]
) => void;

export const useSwitchToNextEpisode = (contentId: string) => {
    const currentEpisode = useCurrentEpisode(contentId);
    const nextEpisode = useNextEpisode(contentId);
    const instance = usePlayerInstance();

    const seriesId = currentEpisode?.tvSeries?.contentId;
    const { episodeContentId: nextEpisodeId, number: nextEpisodeNumber } = nextEpisode || {};

    const startContent = useStartPlayingContent();

    return useCallback<SwitchToNextEpisodeType>(() => {
        if (seriesId && nextEpisodeId && nextEpisodeNumber !== undefined) {
            instance?.pause();
            setPlayingParams({ isPlayingFromBeginning: true });

            startContent({
                contentId: nextEpisodeId ?? '',
                tvSeries: {
                    seriesNumber: nextEpisodeNumber,
                    seasonNumber: nextEpisode?.season?.number,
                },
            });
        }
    }, [
        seriesId,
        nextEpisodeId,
        nextEpisodeNumber,
        instance,
        startContent,
        nextEpisode?.season?.number,
    ]);
};
